import ResumeReviewDashboard from "./ResumeReviewDashboard";

export default ResumeReviewDashboard;
